import React from "react";
import { Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StorageService from "../../../services/StorageService";

class ExamInstanceCellAuditors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      templateConfiguration: null,
    };

    this.showExamFileDownloadReset = this.showExamFileDownloadReset.bind(this);
    this.isDropdownDisabled = this.isDropdownDisabled.bind(this);
  }

  componentDidMount() {
    this.setState({
      user: StorageService.getUser(),
    });
  }

  showSEBSessionQuit() {
    return (
      this.props.examinationStatus === 11 &&
      (this.props.examination.securityLevel === 5 ||
        this.props.examination.securityLevel === 6)
    );
  }

  showExamFileDownloadReset() {
    return (
      this.props.examinationStatus === 11 || this.props.examinationStatus === 31
    );
  }

  hasNothingToShow() {
    return !(this.showExamFileDownloadReset() || this.showSEBSessionQuit());
  }

  isDropdownDisabled() {
    return (
      !(
        this.props.examinationStatus === 11 ||
        this.props.examinationStatus === 21 ||
        this.props.examinationStatus === 30 ||
        this.props.examinationStatus === 32 ||
        this.props.examinationStatus === 60 ||
        this.props.examinationStatus === 61
      ) ||
      this.hasNothingToShow() ||
      ((this.props.examinationStatus === 11 ||
        this.props.examinationStatus === 31) &&
        this.props.instance.status !== 11)
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Row style={{ marginRight: "-12px", float: "right" }}>
        <div style={{}}>
          <DropdownButton
            size="sm"
            disabled={this.isDropdownDisabled()}
            onClick={(event) => event.stopPropagation()}
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faCogs} />}
            className="btn-green"
          >
            {this.showExamFileDownloadReset() && (
              <Dropdown.Item onClick={this.props.onExamFileDownloadReset}>
                {t(
                  "SingleExamination.InstanceTab.ActionCell.ExamFileDownloadResetOption",
                )}
              </Dropdown.Item>
            )}
            {this.showSEBSessionQuit() && (
              <>
                <Dropdown.Header>
                  {t(
                    "SingleExamination.InstanceTab.ActionCell.OptionHeaderSEB",
                  )}
                </Dropdown.Header>
                <Dropdown.Item onClick={this.props.onSEBSessionQuit}>
                  {t(
                    "SingleExamination.InstanceTab.ActionCell.SEBSessionQuitOption",
                  )}
                </Dropdown.Item>
              </>
            )}
          </DropdownButton>
        </div>
      </Row>
    );
  }
}

export default withTranslation()(ExamInstanceCellAuditors);
